import api from "./api";

export class QuestionService {
    async getQuestions() {
        return api.get("/questions");
    }
    
    async getWithAnswer(questionsIds: string[]) {
        return api.post(`/questions/withAnswer`, {questionsIds});
    }
}
